import { Tabs, TabsProps } from "antd";
import { useMemo } from "react";
import { APWorkflowStatusTab } from "../../constants/ap-workflow";
import { usePageStore } from "../../context/PageStoreContext";
import TourEventOrOtherWorkflowTable from "./components/tour-event-or-other-table";
import { IWorkflowType } from "../../interfaces/workflow";
import { WorkflowTypeEnum } from "../../constants/enum";
const DEFAULT_TAB_ACTIVE = "review";

const TourEventOrOtherWorkflowPage: React.FC<IWorkflowType> = ({ type }) => {
  const { getPageValue, setPageValue } = usePageStore();
  const savedTab = getPageValue()?.currentStatus || DEFAULT_TAB_ACTIVE;

  const activeTab = useMemo(() => {
    return savedTab;
  }, [savedTab]);

  const items: TabsProps["items"] = [
    {
      key: `${APWorkflowStatusTab.REVIEW}`,
      label: "Review",
    },
    {
      key: `${APWorkflowStatusTab.EXPORTED}`,
      label: "Exported",
    },
    {
      key: `${APWorkflowStatusTab.COMPLETED}`,
      label: "Completed",
    },
  ];

  return (
    <div>
      <h2 className="title-page">{type === WorkflowTypeEnum.Other ? "Other" : "Tour Event"} Workflow</h2>
      <Tabs activeKey={activeTab} onChange={(key) => setPageValue({ currentStatus: key })} items={items} />
      <TourEventOrOtherWorkflowTable tabKey={activeTab} type={type} />
    </div>
  );
};

export default TourEventOrOtherWorkflowPage;
